// ============================================================
// Masamune OS — Domain enums (mirror of Prisma enums)
// ============================================================
export const RoleKey = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN_AMM: 'ADMIN_AMM',
    PM: 'PM',
    SALES: 'SALES',
    DIV_MGR: 'DIV_MGR',
    RECRUITER: 'RECRUITER',
    DOCENTE: 'DOCENTE',
    COLLABORATORE: 'COLLABORATORE',
    VIEWER: 'VIEWER',
};
export const ROLE_META = {
    SUPER_ADMIN: { label: 'Super Admin', color: '#050514', short: 'SA', canSeeMargin: true },
    ADMIN_AMM: { label: 'Admin Amministrazione', color: '#555555', short: 'AA', canSeeMargin: false },
    PM: { label: 'Project Manager', color: '#2550a0', short: 'PM', canSeeMargin: false },
    SALES: { label: 'Sales / Consultant', color: '#a04f25', short: 'SL', canSeeMargin: false },
    DIV_MGR: { label: 'Division Manager', color: '#4b2570', short: 'DM', canSeeMargin: false },
    RECRUITER: { label: 'Recruiter', color: '#1f6857', short: 'RC', canSeeMargin: false },
    DOCENTE: { label: 'Docente', color: '#705525', short: 'DC', canSeeMargin: false },
    COLLABORATORE: { label: 'Collaboratore', color: '#444444', short: 'CO', canSeeMargin: false },
    VIEWER: { label: 'Viewer', color: '#888888', short: 'VW', canSeeMargin: false },
};
export const ModuleKey = {
    DASHBOARD: 'DASHBOARD',
    CRM: 'CRM',
    MARKETING: 'MARKETING',
    PRODUCT: 'PRODUCT',
    DESIGN: 'DESIGN',
    TALENT: 'TALENT',
    SUPPLIERS: 'SUPPLIERS',
    FATTURAZIONE: 'FATTURAZIONE',
    SERVICES: 'SERVICES',
    VAULT: 'VAULT',
    REPORT: 'REPORT',
    SETTINGS: 'SETTINGS',
    MARGIN: 'MARGIN',
    TASKS: 'TASKS',
    AMMINISTRAZIONE: 'AMMINISTRAZIONE',
    TRATTATIVE: 'TRATTATIVE',
};
export const PermissionLevel = {
    NONE: 'NONE',
    READ: 'READ',
    WRITE: 'WRITE',
    ADMIN: 'ADMIN',
};
export const PERMISSION_LEVEL_ORDER = ['NONE', 'READ', 'WRITE', 'ADMIN'];
export function hasAtLeast(level, required) {
    return PERMISSION_LEVEL_ORDER.indexOf(level) >= PERMISSION_LEVEL_ORDER.indexOf(required);
}
// --- CRM / Clients ---
export const ClientType = { AZIENDA: 'AZIENDA', PIVA: 'PIVA', PRIVATO: 'PRIVATO', PA: 'PA' };
export const ClientStatus = { LEAD: 'LEAD', ATTIVO: 'ATTIVO', IN_PAUSA: 'IN_PAUSA', CHIUSO: 'CHIUSO' };
export const PaymentTerms = {
    BONIFICO_30DF: 'BONIFICO_30DF',
    BONIFICO_60DF: 'BONIFICO_60DF',
    BONIFICO_30FM: 'BONIFICO_30FM',
    ANTICIPATO: 'ANTICIPATO',
};
// --- Projects ---
export const Division = { MKT: 'MKT', PROD: 'PROD', DESIGN: 'DESIGN', TALENT: 'TALENT', ADMIN: 'ADMIN' };
export const DIVISION_LABEL = {
    MKT: 'Digital Marketing',
    PROD: 'Digital Product',
    DESIGN: 'Digital Design',
    TALENT: 'Talent Sourcing',
    ADMIN: 'Amministrazione',
};
export const ProjectStatus = {
    PREVENTIVO: 'PREVENTIVO',
    ATTIVO: 'ATTIVO',
    IN_CORSO: 'IN_CORSO',
    REVISIONE: 'REVISIONE',
    IN_PAUSA: 'IN_PAUSA',
    CHIUSO: 'CHIUSO',
};
export const ProjectModel = {
    ONE_SHOT: 'ONE_SHOT',
    ABBONAMENTO: 'ABBONAMENTO',
    RETAINER: 'RETAINER',
    CONSULENZA: 'CONSULENZA',
    CORSO: 'CORSO',
    RECRUITING: 'RECRUITING',
    SVILUPPO: 'SVILUPPO',
    MAINTENANCE: 'MAINTENANCE',
    MISTO: 'MISTO',
    FORMATEMP: 'FORMATEMP',
    FONDIMPRESA: 'FONDIMPRESA',
    PREVENTIVO_T: 'PREVENTIVO_T',
};
export const RiskLevel = { LOW: 'LOW', MEDIUM: 'MEDIUM', HIGH: 'HIGH' };
// --- Tasks ---
export const TaskStatus = {
    TODO: 'TODO',
    IN_PROGRESS: 'IN_PROGRESS',
    REVIEW: 'REVIEW',
    BLOCKED: 'BLOCKED',
    DONE: 'DONE',
};
export const TaskPriority = { BASSA: 'BASSA', MEDIA: 'MEDIA', ALTA: 'ALTA' };
export const TaskRecurrence = {
    NONE: 'NONE',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY',
};
export const TASK_RECURRENCE_LABEL = {
    NONE: 'Nessuna',
    DAILY: 'Ogni giorno',
    WEEKLY: 'Ogni settimana',
    MONTHLY: 'Ogni mese',
    YEARLY: 'Ogni anno',
};
// --- Trattative (pipeline commerciali) ---
/**
 * A cosa serve una pipeline. Il codice lo guarda solo per decidere quali campi
 * extra hanno senso: i requisiti del bando e il conto del contributo valgono
 * sul voucher, altrove si usa l'importo libero.
 */
export const PipelineKind = {
    VOUCHER: 'VOUCHER',
    RINNOVO: 'RINNOVO',
    ESTENSIONE: 'ESTENSIONE',
    NUOVO: 'NUOVO',
    ALTRO: 'ALTRO',
};
/**
 * Cosa vuol dire uno step: ancora in gioco, portato a casa, finito male.
 * È l'unica cosa che il codice deve sapere di uno step; i nomi ("Ammessa",
 * "Rinnovato", "Vinta") li decide chi configura la pipeline.
 */
export const StageOutcome = { APERTO: 'APERTO', VINTO: 'VINTO', PERSO: 'PERSO' };
export const STAGE_OUTCOME_LABEL = {
    APERTO: 'In corso',
    VINTO: 'Vinta',
    PERSO: 'Chiusa',
};
/** Nome della pipeline del voucher: la chiave stabile è lo slug. */
export const VOUCHER_PIPELINE_SLUG = 'voucher';
/**
 * Nome dello step del voucher che richiede i tre requisiti a posto. È l'unico
 * punto in cui il codice guarda il NOME di uno step, e solo dentro una pipeline
 * VOUCHER: cambiando il nome nel seed va cambiato anche qui.
 */
export const VOUCHER_REQUISITI_STAGE = 'Requisiti verificati';
// --- Requisiti del bando e conti del voucher ---
export const ReqStatus = { DA_VERIFICARE: 'DA_VERIFICARE', OK: 'OK', MANCA: 'MANCA' };
export const REQ_STATUS_LABEL = {
    DA_VERIFICARE: 'Da verificare',
    OK: 'A posto',
    MANCA: 'Manca',
};
/** I tre requisiti che la misura chiede di dimostrare. */
export const DEAL_REQUISITI = [
    { key: 'reqConnettivita', label: 'Connettività', hint: 'almeno 30 Mb, con contratto' },
    { key: 'reqPolizza', label: 'Polizza catastrofale', hint: 'attiva' },
    { key: 'reqDurc', label: 'DURC', hint: 'regolare' },
];
/**
 * Voucher Cloud e Cybersecurity (MIMIT): 50% a fondo perduto, due sole
 * configurazioni. Da qui si calcolano contributo e ricavo: non si digitano.
 */
export const VoucherScenario = { S20K: 'S20K', S40K: 'S40K' };
export const VOUCHER_SCENARIO_LABEL = {
    S20K: '20.000 di spesa · 10.000 di contributo',
    S40K: '40.000 di spesa · 20.000 di contributo',
};
/** Etichetta corta per liste e card. */
export const VOUCHER_SCENARIO_SHORT = { S20K: '20k', S40K: '40k' };
export const VOUCHER_SPESA = { S20K: 20_000, S40K: 40_000 };
export const VOUCHER_CONTRIBUTO = { S20K: 10_000, S40K: 20_000 };
/** Quanto ci guadagna Masamune: fisso + success fee sul contributo + canone. */
export const VOUCHER_FEE_ISTRUTTORIA = 1_200;
export const VOUCHER_SUCCESS_FEE_RATE = 0.06;
export const VOUCHER_CANONE_MENSILE = 120;
/** Contributo massimo del bando: 50% della spesa, ma non oltre 20.000. */
export const VOUCHER_CONTRIBUTO_MAX = 20_000;
/**
 * Contributo a fondo perduto su una spesa qualsiasi: metà, con il tetto dei
 * 20.000. Le due configurazioni commerciali (20k e 40k) restano i casi tipici,
 * ma un progetto può valere anche 30.000, e allora il contributo è 15.000.
 */
export function voucherContributo(spesa) {
    return Math.min(Math.max(0, spesa) / 2, VOUCHER_CONTRIBUTO_MAX);
}
/**
 * Quanto incassa Masamune per GESTIRE la pratica: 1.200 di presentazione e
 * istruttoria (una tantum) + 6% del contributo a esito positivo + 120 al mese
 * di supporto e rendicontazione.
 *
 * ⚠️ Non è il valore della trattativa: è un servizio venduto SOPRA il progetto.
 * Il progetto (20.000, 30.000, 40.000…) Masamune lo fattura per intero, perché
 * eroga lei i servizi finanziati (verificato il 18/09/2026 sulle righe dei
 * preventivi FiC 192 e 193: sono tutte voci Masamune). Chi confonde i due numeri
 * sottostima la pipeline di circa quattro volte.
 */
export function voucherFeeGestione(contributo, mesiCanone) {
    const success = Math.max(0, contributo) * VOUCHER_SUCCESS_FEE_RATE;
    return VOUCHER_FEE_ISTRUTTORIA + success + VOUCHER_CANONE_MENSILE * Math.max(0, mesiCanone);
}
/** @deprecated usa voucherFeeGestione: questo è il ricavo della sola pratica. */
export function voucherRicavo(scenario, mesiCanone) {
    return voucherFeeGestione(VOUCHER_CONTRIBUTO[scenario], mesiCanone);
}
export const DealEventKind = { STAGE: 'STAGE', NOTA: 'NOTA', CONTATTO: 'CONTATTO' };
export const DEAL_EVENT_KIND_LABEL = {
    STAGE: 'Fase',
    NOTA: 'Nota',
    CONTATTO: 'Contatto',
};
/** Da quanti giorni senza un evento una trattativa si considera ferma. */
export const DEAL_STALE_DAYS = 14;
// --- Documents ---
export const DocGroup = {
    CONTRATTI: 'CONTRATTI',
    BRIEF: 'BRIEF',
    DESIGN: 'DESIGN',
    DELIVERY: 'DELIVERY',
    ALTRO: 'ALTRO',
};
// --- Communications ---
export const CommKind = {
    EMAIL: 'EMAIL',
    CALL: 'CALL',
    MEETING: 'MEETING',
    NOTE: 'NOTE',
};
// --- Invoices ---
export const InvoiceType = {
    FATTURA: 'FATTURA',
    PROFORMA: 'PROFORMA',
    NOTA_CREDITO: 'NOTA_CREDITO',
    AVVISO_PAGAMENTO: 'AVVISO_PAGAMENTO',
};
export const InvoiceStatus = {
    BOZZA: 'BOZZA',
    EMESSA: 'EMESSA',
    INVIATA: 'INVIATA',
    PAGATA: 'PAGATA',
    SCADUTA: 'SCADUTA',
    ANNULLATA: 'ANNULLATA',
};
export const QuoteStatus = {
    BOZZA: 'BOZZA',
    INVIATO: 'INVIATO',
    VISUALIZZATO: 'VISUALIZZATO',
    ACCETTATO: 'ACCETTATO',
    RIFIUTATO: 'RIFIUTATO',
    SCADUTO: 'SCADUTO',
    CONVERTITO: 'CONVERTITO',
};
export const PaymentMethod = {
    BONIFICO: 'BONIFICO',
    SDD: 'SDD',
    CARTA: 'CARTA',
    CASH: 'CASH',
    ALTRO: 'ALTRO',
};
export const SALStatus = { PREVISTA: 'PREVISTA', EMESSA: 'EMESSA', PAGATA: 'PAGATA' };
export const ChangeReqStatus = {
    IN_VALUTAZIONE: 'IN_VALUTAZIONE',
    APPROVATA: 'APPROVATA',
    RIFIUTATA: 'RIFIUTATA',
};
// --- Costs ---
export const CostCategory = {
    SVILUPPO: 'SVILUPPO',
    DESIGN: 'DESIGN',
    PM: 'PM',
    PROFESSIONISTI: 'PROFESSIONISTI',
    QA: 'QA',
    INFRASTRUTTURA: 'INFRASTRUTTURA',
    TOOLS: 'TOOLS',
    DOCENTI: 'DOCENTI',
    RECRUITER: 'RECRUITER',
    ADV: 'ADV',
    FORN: 'FORN',
    ALTRO: 'ALTRO',
};
// --- Talent ---
export const CourseType = {
    FORMATEMP: 'FORMATEMP',
    FONDIMPRESA: 'FONDIMPRESA',
    INTERNO: 'INTERNO',
};
export const CourseStatus = {
    ISCRIZIONI: 'ISCRIZIONI',
    SELEZIONE: 'SELEZIONE',
    AULA: 'AULA',
    VALUTAZIONE: 'VALUTAZIONE',
    PLACEMENT: 'PLACEMENT',
    RENDICONTAZIONE: 'RENDICONTAZIONE',
    CHIUSO: 'CHIUSO',
};
export const CourseMode = {
    BLENDED: 'BLENDED',
    REMOTO: 'REMOTO',
    IN_HOUSE: 'IN_HOUSE',
    IN_PRESENZA: 'IN_PRESENZA',
};
export const CandidateStage = {
    NUOVO_CANDIDATO: 'NUOVO_CANDIDATO',
    SCREENING: 'SCREENING',
    IDONEO: 'IDONEO',
    ISCRITTO_AL_CORSO: 'ISCRITTO_AL_CORSO',
    FREQUENTANTE: 'FREQUENTANTE',
    PRONTO_PER_PLACEMENT: 'PRONTO_PER_PLACEMENT',
    PROPOSTO_AD_AZIENDA: 'PROPOSTO_AD_AZIENDA',
    COLLOQUIO_FISSATO: 'COLLOQUIO_FISSATO',
    SOMMINISTRATO: 'SOMMINISTRATO',
    ASSUNTO: 'ASSUNTO',
    SCARTATO: 'SCARTATO',
};
export const AttendanceStatus = {
    PRESENTE: 'PRESENTE',
    ASSENTE: 'ASSENTE',
    GIUSTIFICATO: 'GIUSTIFICATO',
    RITARDO: 'RITARDO',
};
export const PlacementStatus = {
    PROPOSTA: 'PROPOSTA',
    COLLOQUIO_FISSATO: 'COLLOQUIO_FISSATO',
    SOMMINISTRATO: 'SOMMINISTRATO',
    ASSUNTO: 'ASSUNTO',
    RIFIUTATO: 'RIFIUTATO',
};
// --- Body Rental (somministrazione a margine) ---
export const BodyRentalStatus = {
    RICHIESTA: 'RICHIESTA',
    RICERCA: 'RICERCA',
    PROPOSTO: 'PROPOSTO',
    ATTIVO: 'ATTIVO',
    TERMINATO: 'TERMINATO',
    ANNULLATO: 'ANNULLATO',
};
export const BodyRentalRateUnit = {
    HOUR: 'HOUR',
    DAY: 'DAY',
    MONTH: 'MONTH',
};
// --- Vault ---
export const VaultCategory = {
    PIATTAFORMA_CLIENTE: 'PIATTAFORMA_CLIENTE',
    HOSTING_DOMINIO: 'HOSTING_DOMINIO',
    ADV_PLATFORM: 'ADV_PLATFORM',
    INFRASTRUTTURA: 'INFRASTRUTTURA',
    AMMINISTRATIVA: 'AMMINISTRATIVA',
    DESIGN_TOOL: 'DESIGN_TOOL',
    ALTRO: 'ALTRO',
};
export const VaultAction = {
    VIEWED: 'VIEWED',
    REVEALED: 'REVEALED',
    COPIED: 'COPIED',
    CREATED: 'CREATED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED',
};
// --- Managed Services (Hosting, GoDeal, ecc — subscription-based) ---
// AURA_OS sta a parte da CUSTOM perche' non e' roba nostra rivenduta: e' il
// canone del gestionale clinico del fratello, che su Stripe si riconosce dai
// metadata del prodotto (`organization_id` / `source: auraos_migrate`) e non dal
// nome, visto che i due abbonamenti si chiamano col nome dello studio
// ("Abbonamento La Bruna", "Abbonamento Roberta Milana Studio").
export const ManagedServiceType = {
    HOSTING: 'HOSTING',
    GODEAL: 'GODEAL',
    AURA_OS: 'AURA_OS',
    CUSTOM: 'CUSTOM',
};
export const MANAGED_SERVICE_LABEL = {
    HOSTING: 'Hosting Masamune',
    GODEAL: 'GoDeal',
    AURA_OS: 'Aura OS',
    CUSTOM: 'Servizio custom',
};
export const ServiceProvider = {
    STRIPE: 'STRIPE',
    HIGHLEVEL: 'HIGHLEVEL',
    MANUAL: 'MANUAL',
};
export const ServiceStatus = {
    TRIALING: 'TRIALING',
    ACTIVE: 'ACTIVE',
    PAST_DUE: 'PAST_DUE',
    PAUSED: 'PAUSED',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
};
export const SERVICE_STATUS_LABEL = {
    TRIALING: 'In trial',
    ACTIVE: 'Attivo',
    PAST_DUE: 'In ritardo',
    PAUSED: 'In pausa',
    CANCELLED: 'Cancellato',
    EXPIRED: 'Scaduto',
};
export const BillingCycle = {
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    YEARLY: 'YEARLY',
};
export const ServiceEventKind = {
    CREATED: 'CREATED',
    ACTIVATED: 'ACTIVATED',
    PAUSED: 'PAUSED',
    RESUMED: 'RESUMED',
    CANCELLED: 'CANCELLED',
    PAYMENT_OK: 'PAYMENT_OK',
    PAYMENT_FAILED: 'PAYMENT_FAILED',
    PLAN_CHANGED: 'PLAN_CHANGED',
    RENEWED: 'RENEWED',
    SYNCED: 'SYNCED',
    NOTE: 'NOTE',
};
// --- Alerts / Notifications ---
export const AlertType = { ALERT: 'ALERT', WARN: 'WARN', INFO: 'INFO' };
export const AlertIcon = {
    ALERT: 'ALERT',
    INVOICE: 'INVOICE',
    CALENDAR: 'CALENDAR',
    TALENT: 'TALENT',
    FILE: 'FILE',
    OTHER: 'OTHER',
};
export const ActivityKind = {
    TASK: 'TASK',
    COMMIT: 'COMMIT',
    ALERT: 'ALERT',
    DOC: 'DOC',
    BUDGET: 'BUDGET',
    COMM: 'COMM',
    QA: 'QA',
    OTHER: 'OTHER',
};
// --- Amministrazione (conti, movimenti, rate, fornitori, ricorrenti, tasse, cassa) ---
export const BankProvider = { QONTO: 'QONTO', CASH: 'CASH' };
export const TxSide = { DEBIT: 'DEBIT', CREDIT: 'CREDIT' };
// STORNATA = rata "reversed" su FattureInCloud (documento stornato, non conta come credito).
export const InvoicePaymentStatus = { DA_INCASSARE: 'DA_INCASSARE', INCASSATA: 'INCASSATA', STORNATA: 'STORNATA' };
export const PayablePaymentStatus = { DA_PAGARE: 'DA_PAGARE', PAGATA: 'PAGATA', STORNATA: 'STORNATA' };
export const PayableKind = { EXPENSE: 'EXPENSE', PASSIVE_CREDIT_NOTE: 'PASSIVE_CREDIT_NOTE' };
// FINANZIATA = il fornitore l'ha gia' incassata dalla finanziaria (auto, macchinari):
// noi paghiamo la rata mensile, che sta gia' fra le uscite ricorrenti. Fuori da
// "da pagare", dai totali fornitori e dal forecast, altrimenti conta due volte.
export const PayableStatus = { DA_PAGARE: 'DA_PAGARE', PARZIALE: 'PARZIALE', PAGATA: 'PAGATA', ANNULLATA: 'ANNULLATA', FINANZIATA: 'FINANZIATA' };
export const PAYABLE_STATUS_LABEL = {
    DA_PAGARE: 'Da pagare',
    PARZIALE: 'Pagata in parte',
    PAGATA: 'Pagata',
    ANNULLATA: 'Annullata',
    FINANZIATA: 'Pagata dalla finanziaria, a rate',
};
export const AdminPayMethod = {
    BONIFICO: 'BONIFICO',
    CONTANTI: 'CONTANTI',
    STRIPE: 'STRIPE',
    CARTA: 'CARTA',
    RIBA: 'RIBA',
    ADDEBITO: 'ADDEBITO',
    COMPENSAZIONE: 'COMPENSAZIONE',
    ALTRO: 'ALTRO',
};
/** Come e' stata pagata una voce: parole intere, niente sigle ("RiBa") ne' marchi soli ("Stripe"). */
export const ADMIN_PAY_METHOD_LABEL = {
    BONIFICO: 'Bonifico',
    CONTANTI: 'Contanti',
    STRIPE: 'Carta online (Stripe)',
    CARTA: 'Carta',
    RIBA: 'Ricevuta bancaria',
    ADDEBITO: 'Addebito automatico',
    COMPENSAZIONE: 'Compensata con un nostro debito',
    ALTRO: 'Altro metodo',
};
export const RecurringCycle = { MONTHLY: 'MONTHLY', BIMONTHLY: 'BIMONTHLY', QUARTERLY: 'QUARTERLY', YEARLY: 'YEARLY' };
export const RECURRING_CYCLE_LABEL = {
    MONTHLY: 'Mensile',
    BIMONTHLY: 'Bimestrale',
    QUARTERLY: 'Trimestrale',
    YEARLY: 'Annuale',
};
export const RECURRING_CYCLE_MONTHS = { MONTHLY: 1, BIMONTHLY: 2, QUARTERLY: 3, YEARLY: 12 };
export const AdminCategory = {
    AFFITTO: 'AFFITTO',
    UTENZE: 'UTENZE',
    STIPENDI: 'STIPENDI',
    COMPENSO_AMMINISTRATORE: 'COMPENSO_AMMINISTRATORE',
    TFR: 'TFR',
    COLLABORATORI: 'COLLABORATORI',
    SAAS: 'SAAS',
    AUTO: 'AUTO',
    CONSULENTI: 'CONSULENTI',
    TASSE: 'TASSE',
    FORNITORI: 'FORNITORI',
    CLIENTI: 'CLIENTI',
    ALTRO: 'ALTRO',
};
/** Tipi di spesa: gli stessi nomi dei gruppi di Spese › Spese fisse. */
export const ADMIN_CATEGORY_LABEL = {
    AFFITTO: 'Affitto',
    UTENZE: 'Telefono, internet ed energia',
    STIPENDI: 'Stipendi',
    COMPENSO_AMMINISTRATORE: "Compenso dell'amministratore",
    TFR: 'TFR e TFM',
    COLLABORATORI: 'Collaboratori',
    SAAS: 'Software e abbonamenti online',
    AUTO: 'Auto',
    CONSULENTI: 'Consulenti',
    TASSE: 'Tasse',
    FORNITORI: 'Fornitori',
    CLIENTI: 'Clienti',
    ALTRO: 'Assicurazioni, banca e altre spese',
};
export const TaxKind = {
    F24_DIPENDENTI: 'F24_DIPENDENTI',
    F24_IRPEF: 'F24_IRPEF',
    IRES_IRAP: 'IRES_IRAP',
    INPS: 'INPS',
    IVA_TRIMESTRALE: 'IVA_TRIMESTRALE',
    IVA_ARRETRATA: 'IVA_ARRETRATA',
    ADER: 'ADER',
    CAMERALE: 'CAMERALE',
    ALTRO: 'ALTRO',
};
/** Tutti i tipi, nell'ordine in cui compaiono nei menu a tendina. */
export const TAX_KINDS = ['F24_DIPENDENTI', 'F24_IRPEF', 'IVA_TRIMESTRALE', 'IVA_ARRETRATA', 'IRES_IRAP', 'ADER', 'INPS', 'CAMERALE', 'ALTRO'];
/** Nomi a schermo: parole semplici, niente sigle da commercialista dove si puo'. */
export const TAX_KIND_LABEL = {
    F24_DIPENDENTI: 'F24 dei dipendenti',
    F24_IRPEF: 'Ritenute dei collaboratori',
    IRES_IRAP: 'Imposte della società (IRES e IRAP)',
    INPS: 'Contributi INPS',
    IVA_TRIMESTRALE: 'IVA del trimestre',
    IVA_ARRETRATA: 'IVA arretrata',
    ADER: 'Piano a rate (Agenzia Riscossione)',
    CAMERALE: 'Diritto annuale della Camera di commercio',
    ALTRO: 'Altro versamento al fisco',
};
/** Le tasse che concorrono all'IVA residua per anno. */
export const IVA_TAX_KINDS = ['IVA_TRIMESTRALE', 'IVA_ARRETRATA'];
/**
 * Le viste di Fisco. Ogni tipo di tassa sta in un gruppo solo (SPEC 24/9):
 * le ritenute dei collaboratori (F24_IRPEF) NON vanno in F24 dipendenti ma in
 * Altri versamenti; l'INPS sta in Debiti a rate, perche' oggi l'unico INPS
 * arretrato e' dentro un piano a rate, mentre i contributi correnti sono
 * gia' dentro l'F24 dei dipendenti.
 */
export const TaxGroup = {
    F24_DIPENDENTI: 'F24_DIPENDENTI',
    IVA: 'IVA',
    SOCIETA: 'SOCIETA',
    RATE: 'RATE',
    ALTRI: 'ALTRI',
};
/** Ordine delle viste in pagina. */
export const TAX_GROUPS = ['F24_DIPENDENTI', 'IVA', 'SOCIETA', 'RATE', 'ALTRI'];
export const TAX_GROUP = {
    F24_DIPENDENTI: 'F24_DIPENDENTI',
    IVA_TRIMESTRALE: 'IVA',
    IVA_ARRETRATA: 'IVA',
    IRES_IRAP: 'SOCIETA',
    ADER: 'RATE',
    INPS: 'RATE',
    F24_IRPEF: 'ALTRI',
    CAMERALE: 'ALTRI',
    ALTRO: 'ALTRI',
};
/**
 * Nomi delle viste di Fisco (e dei gruppi nelle righe). Regola etichette
 * (SPEC, 24/9): letti da soli devono dire di cosa si parla, quindi "Altri
 * versamenti al fisco" e non "Altri versamenti". Le linguette della pagina
 * usano gli stessi nomi (lib/adminRoutes.ts, VISTA_LABEL.fisco).
 */
export const TAX_GROUP_LABEL = {
    F24_DIPENDENTI: 'F24 dei dipendenti',
    IVA: 'IVA',
    SOCIETA: 'Imposte della società (IRES e IRAP)',
    RATE: 'Debiti a rate',
    ALTRI: 'Altri versamenti al fisco',
};
/** Una riga sotto il titolo della vista: cosa sono, detto a chi non e' del mestiere. */
export const TAX_GROUP_HINT = {
    F24_DIPENDENTI: 'Tasse e contributi trattenuti nelle buste paga: si versano con un F24 entro il 16 del mese dopo.',
    IVA: "L'IVA che mettiamo in fattura non è nostra: la incassiamo per lo Stato e la versiamo ogni tre mesi, meno quella pagata ai fornitori.",
    SOCIETA: "IRES allo Stato e IRAP alla Regione, sui conti dell'anno prima: saldo e acconti, spesso a rate da luglio a dicembre.",
    RATE: 'Debiti vecchi già messi a posto con un piano a rate: finché si paga la rata siamo in regola.',
    ALTRI: 'Ritenute dei collaboratori, Camera di commercio, libri sociali, imposta di registro e gli altri versamenti.',
};
/** I tipi di tassa di un gruppo (per i filtri delle viste). */
export function taxKindsOfGroup(group) {
    return TAX_KINDS.filter((k) => TAX_GROUP[k] === group);
}
export const TaxStatus = { APERTA: 'APERTA', PARZIALE: 'PARZIALE', PAGATA: 'PAGATA' };
export const TAX_STATUS_LABEL = {
    APERTA: 'Da pagare',
    PARZIALE: 'Pagata in parte',
    PAGATA: 'Pagata',
};
/**
 * Da dove viene la cifra di una scadenza fiscale. Non dice se e' pagata.
 * STIMA = media o proiezione; CALCOLATO = calcolata da noi dalle fatture
 * (non e' ancora l'F24 del commercialista); CONFERMATO = c'e' il documento
 * del commercialista o il pagamento in banca; FIC = da FattureInCloud.
 */
export const TaxSource = { STIMA: 'STIMA', CALCOLATO: 'CALCOLATO', CONFERMATO: 'CONFERMATO', FIC: 'FIC' };
export const TAX_SOURCE_LABEL = {
    STIMA: 'Stima',
    CALCOLATO: 'Calcolata da noi',
    CONFERMATO: 'Confermata',
    FIC: 'Da FattureInCloud',
};
/** Le fonti che non sono un documento ufficiale: la cifra puo' ancora cambiare. */
export const TAX_SOURCES_PROVVISORIE = ['STIMA', 'CALCOLATO'];
// ─── Dipendenti ─────────────────────────────────────────────────────
export const EmployeeKind = { DIPENDENTE: 'DIPENDENTE', APPRENDISTA: 'APPRENDISTA', AMMINISTRATORE: 'AMMINISTRATORE' };
export const EMPLOYEE_KIND_LABEL = {
    DIPENDENTE: 'Dipendente',
    APPRENDISTA: 'Apprendista',
    AMMINISTRATORE: 'Amministratore con busta paga',
};
/** Cosa paga un bonifico a una persona in busta paga. */
export const PayrollKind = { STIPENDIO: 'STIPENDIO', RIMBORSO_KM: 'RIMBORSO_KM', TFR: 'TFR', ALTRO: 'ALTRO' };
export const PAYROLL_KIND_LABEL = {
    STIPENDIO: 'Stipendio',
    RIMBORSO_KM: 'Rimborso km o spese',
    TFR: 'TFR',
    ALTRO: 'Altro bonifico',
};
// PERSONALE_ANDREA: fuori da ogni totale societario, visibile solo a SUPER_ADMIN.
export const AdminEntity = { MASAMUNE: 'MASAMUNE', PERSONALE_ANDREA: 'PERSONALE_ANDREA' };
export const CashDirection = { IN: 'IN', OUT: 'OUT' };
export const CashEntryStatus = { PREVISTO: 'PREVISTO', PAGATO: 'PAGATO' };
export const SyncProvider = { QONTO: 'QONTO', FIC: 'FIC' };
/** Origine di una riga della lista uscite unificata. */
export const UsciteSource = { PAYABLE: 'PAYABLE', RECURRING: 'RECURRING', TAX: 'TAX', CASH: 'CASH' };
/**
 * Perche' un documento e' stato cestinato (tolto dal gestionale).
 *
 * ATTENZIONE: cestinare NON e' un'operazione fiscale. Il documento resta su
 * FattureInCloud e nel cassetto fiscale: se una fattura e' stata davvero emessa
 * e va annullata per il fisco serve una nota di credito, che fa il commercialista.
 * Qui si tolgono solo di mezzo i documenti che nel gestionale non devono esserci:
 * le fatture scartate dallo SdI (mai esistite), i doppioni, gli errori.
 */
export const IgnoreReason = {
    SCARTATA_SDI: 'SCARTATA_SDI',
    DOPPIONE: 'DOPPIONE',
    ERRORE: 'ERRORE',
    ANNULLATA_FIC: 'ANNULLATA_FIC',
    ALTRO: 'ALTRO',
};
/** Perche' una fattura e' stata tolta dall'elenco: parole intere, "SdI" solo fra parentesi. */
export const IGNORE_REASON_LABEL = {
    SCARTATA_SDI: "Rifiutata dall'Agenzia delle Entrate (SdI)",
    DOPPIONE: 'È un doppione',
    ERRORE: 'Emessa per errore',
    ANNULLATA_FIC: 'Già annullata su FattureInCloud',
    ALTRO: 'Altro motivo',
};
/** Cosa si aggancia a un movimento Qonto. */
export const TxMatchKind = {
    INVOICE_PAYMENT: 'INVOICE_PAYMENT',
    PAYABLE_PAYMENT: 'PAYABLE_PAYMENT',
    TAX_INSTALLMENT: 'TAX_INSTALLMENT',
    CASH_ENTRY: 'CASH_ENTRY',
};
//# sourceMappingURL=enums.js.map